import { render, staticRenderFns } from "./Float.vue?vue&type=template&id=078b486a&scoped=true&"
import script from "./Float.vue?vue&type=script&lang=js&"
export * from "./Float.vue?vue&type=script&lang=js&"
import style0 from "./Float.vue?vue&type=style&index=0&id=078b486a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078b486a",
  null
  
)

export default component.exports